import { Component } from 'preact';
import {connect} from "react-redux";;
import {bindActionCreators} from "redux";

import SubscribeForm from './SubscribeForm';
import Status from './Status';
import LoadingSpinner from '../spinner/LoadingSpinner';
import Modal from "../ui/Modal";
import ConsentDetail from "../blocks/raffleForm/ConsentDetail";

import styles from './styles.scss'

import {
    updateTextInputAction,
    updateCountryAction,
    updateConsentCheckboxInput,
    tryAgainToSubscribe
} from '../../actions/SubscribeActions';
import {
    closeConsentModalAction,
    openConsentModalAction
} from '../../actions/ConsentModalActions';
import DeliveryRepository from "../../repositories/DeliveryRepository";
import ConsentRepository from "../../repositories/ConsentRepository";
import SubscribeRepository from "../../repositories/SubscribeRepository";

class Subscribe extends Component {
    mobileBreakpoint = 992;

    constructor(props) {
        super(props);

        this.state = {
            isMobile: false
        }
    }

    openConsentModal = (title, detailUrl) => {
        const {openConsentModalAction} = this.props;
        openConsentModalAction(title, detailUrl);
    };

    onConsentModalClose = () => {
        const {closeConsentModalAction} = this.props;
        closeConsentModalAction();
    };

    subscribe = () => {
        const {updateCountryAction, updateConsentCheckboxInput, updateTextInputAction, subscribe, consents} = this.props;
        const {email, country, checkbox} = this.props.data;

        if(email.value === '') {
            updateTextInputAction('email', {touched: true, valid: false, errors: [{msg: 'This field can not be empty'}]});
        }

        if(country.value === '') {
            updateCountryAction('country', {touched: true});
        }

        if(checkbox.value === false) {
            updateConsentCheckboxInput('checkbox', {touched: true})
        }

        if(email.valid && country.value !== '' && checkbox.value) {
            subscribe(email.value, country.value, consents);
        }
    };

    handleResize = () => {
        const { isMobile } = this.state;
        const currentIsMobile = window.innerWidth < this.mobileBreakpoint;

        if (isMobile !== currentIsMobile) {
            this.setState({
                isMobile: currentIsMobile
            })
        }
    };

    componentDidMount() {
        const {fetchCountries, fetchConsents} = this.props;

        fetchCountries();
        fetchConsents();

        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    render() {
        const {
            updateTextInputAction,
            updateCountryAction,
            updateConsentCheckboxInput,
            tryAgainToSubscribe,
            countries,
            consents,
            consentModal,
            isPending,
            requested,
            requestResult
        } = this.props;
        const {email, country, checkbox} = this.props.data;
        const { isMobile } = this.state;

        return(
            <div className={styles.subscribe}>
                {!requested ? (
                    !isPending ? (
                        <div>
                            <h1 className={styles.title}>Oh no! There are no open raffles right now.</h1>
                            <p className={styles.subtitle}>Our stock is updated every day. Subscribe to our newsletters and stay updated!</p>
                            <SubscribeForm
                                countries={countries}
                                consents={consents}
                                email={email}
                                country={country}
                                checkbox={checkbox}
                                isMobile={isMobile}
                                subscribe={this.subscribe}
                                onTextInputClick={updateTextInputAction}
                                onCountryChange={updateCountryAction}
                                onCheckboxClick={updateConsentCheckboxInput}
                                openConsentModal={this.openConsentModal}
                            />
                        </div>
                    ) : <LoadingSpinner className={styles.spinner} active />
                ) : <Status requestResult={requestResult} tryAgainToSubscribe={tryAgainToSubscribe}/>}

                <Modal {...{
                    onHide: this.onConsentModalClose,
                    title: consentModal.title,
                    show: consentModal.show,
                    footer: <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.onConsentModalClose}>Close</button>,
                    modalClasses: 'modal-dialog-centered modal-lg'
                }}>
                    <ConsentDetail detailUrl={consentModal.detailUrl} />
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    data: state.subscribe.fields,
    isPending: state.subscribe.isPending,
    requested: state.subscribe.requested,
    requestResult: state.subscribe.requestResult,
    countries: state.raffleForm.countries,
    consents: state.raffleForm.consents,
    consentModal: state.raffleForm.consentModal
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateTextInputAction,
    updateCountryAction,
    updateConsentCheckboxInput,
    tryAgainToSubscribe,
    openConsentModalAction,
    closeConsentModalAction,
    fetchCountries: DeliveryRepository.fetchCountries,
    fetchConsents: ConsentRepository.fetchConsents,
    subscribe: SubscribeRepository.subscribe
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Subscribe);



// WEBPACK FOOTER //
// ./components/subscribe/index.js